module.exports = __webpack_public_path__ + "img/image-ebook.8cb32c3e.png";